import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BlockTitle = _resolveComponent("BlockTitle")!
  const _component_ArticleCard = _resolveComponent("ArticleCard")!
  const _component_ArticleBlock = _resolveComponent("ArticleBlock")!

  return (_openBlock(), _createBlock(_component_ArticleBlock, null, {
    default: _withCtx(() => [
      _createVNode(_component_BlockTitle, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.trans("general.news")), 1)
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article) => {
        return (_openBlock(), _createElementBlock("div", {
          key: article.id
        }, [
          _createVNode(_component_ArticleCard, {
            class: "d-none@md",
            article: article
          }, null, 8, ["article"]),
          _createVNode(_component_ArticleCard, {
            class: "d-none d-block@md",
            article: article,
            isTwoColumns: ""
          }, null, 8, ["article"])
        ]))
      }), 128)),
      _hoisted_1
    ]),
    _: 1
  }))
}